import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { getCurrentUser } from "../../Services/authService";
// import publicIp from "react-public-ip";
import { formatTotalHours, getFieldData, getMonthLastDay, getTotalHours } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUserDetails } from "../../app/store/auth";
import { useGetUserDetailsQuery } from "../../app/store/authApiSlice";
import {
  getGenerateBulkInvoiceStatus,
  partnerCandidatesInvGenerated
} from "../../app/store/partner";
import { useLoadPartnerAllCandidateRptQuery, usePartnerCandidateGenerateBulkInvMutation } from "../../app/store/partnerApiSlice";
import { generatedInvoiePdfReceived, getGeneratedInvPdf } from "../../app/store/timeLogInvoice";
import { usePrintGeneratedInvoiceMutation } from "../../app/store/timeLogApiSlice";
import { getAlert } from "../../Services/appAlerts";

const GENERATE_INVOICE_STYLES = {
  modalContent: {
    borderRadius: "24px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalDialog: {
    maxWidth: "1120px"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "4px"
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px"
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px"
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0
  },
  previewCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px"
  },
  previewHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    flexWrap: "wrap",
    marginBottom: "14px"
  },
  previewTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "4px"
  },
  previewSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.6
  },
  invoicePill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 12px",
    fontSize: "12px",
    fontWeight: 600
  },
  previewShell: {
    maxHeight: "700px",
    overflow: "auto",
    borderRadius: "16px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    padding: "18px"
  },
  printBody: {
    width: "100%",
    padding: "18px 22px",
    backgroundColor: "#ffffff",
    color: "#111827",
    fontFamily: "Arial, Helvetica, sans-serif"
  },
  printHeaderTable: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    marginBottom: "16px",
    border: "1px solid #cbd5e1",
    backgroundColor: "#ffffff"
  },
  printHeaderLogoCell: {
    width: "12%",
    border: "1px solid #cbd5e1",
    verticalAlign: "middle",
    backgroundColor: "#f8fafc",
    padding: "10px"
  },
  printHeaderTitleCell: {
    width: "42%",
    // border: "1px solid #cbd5e1",
    padding: "14px",
    textAlign: "right",
    verticalAlign: "middle",
    // backgroundColor: "#f8fafc"
  },
  printLogoFrame: {
    display: "inline-block",
    minWidth: "150px",
    minHeight: "50px",
    padding: "8px 10px",
    border: "1px solid #e2e8f0",
    backgroundColor: "#ffffff",
    verticalAlign: "middle"
  },
  printLogo: {
    display: "block",
    width: "150px",
    maxWidth: "150px",
    height: "auto",
    maxHeight: "50px",
    objectFit: "contain",
    border: "1px solid #e2e8f0",
  },
  printLogoPlaceholder: {
    display: "block",
    width: "150px",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: "bold",
    lineHeight: "50px",
    textAlign: "center",
    textTransform: "uppercase"
  },
  printHeaderBrandText: {
    display: "inline-block",
    paddingLeft: "12px",
    verticalAlign: "middle"
  },
  printHeaderBrandLabel: {
    color: "#475569",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: "0.08em",
    margin: "0 0 5px",
    padding: 0,
    textTransform: "uppercase"
  },
  printHeaderBrandValue: {
    color: "#0f172a",
    fontSize: "13px",
    fontWeight: "bold",
    margin: 0,
    padding: 0
  },
  printTitleText: {
    fontSize: "32px",
    fontWeight: "bold",
    letterSpacing: "0.06em",
    padding: 0,
    color: "#0f172a",
    margin: 0
  },
  printHeaderSubText: {
    color: "#64748b",
    fontSize: "10px",
    fontWeight: "bold",
    margin: "6px 0 0",
    padding: 0,
    textTransform: "uppercase"
  },
  printMetaTable: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    marginBottom: "18px",
    border: "1px solid #cbd5e1",
    backgroundColor: "#ffffff"
  },
  printMetaCell: {
    border: "1px solid #cbd5e1",
    padding: "5px 12px",
    verticalAlign: "top",
    backgroundColor: "#f8fafc"
  },
  printMetaCellAlt: {
    border: "1px solid #bfdbfe",
    padding: "5px 12px",
    verticalAlign: "top",
    textAlign: "right",
    backgroundColor: "#eff6ff"
  },
  printMetaLabel: {
    color: "#475569",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: "0.06em",
    margin: "0 0 5px",
    padding: 0,
    textTransform: "uppercase"
  },
  printMetaValue: {
    whiteSpace: "nowrap",
    color: "#111827",
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: 1.15,
    margin: "0 0 5px",
    padding: 0
  },
  printMetaHint: {
    color: "#64748b",
    fontSize: "10px",
    fontWeight: "bold",
    lineHeight: 1.3,
    margin: 0,
    padding: 0
  },
  printPartyTable: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    marginBottom: "14px",
    border: "1px solid #cbd5e1",
    backgroundColor: "#ffffff"
  },
  printPanelTitle: {
    fontSize: "10px",
    fontWeight: "bold",
    color: "#475569",
    padding: "8px 10px",
    backgroundColor: "#f8fafc",
    border: "1px solid #cbd5e1",
    letterSpacing: "0.06em",
    textTransform: "uppercase"
  },
  printPanelTitleAlt: {
    fontSize: "10px",
    fontWeight: "bold",
    color: "#1d4ed8",
    padding: "8px 10px",
    backgroundColor: "#eff6ff",
    border: "1px solid #bfdbfe",
    letterSpacing: "0.06em",
    textTransform: "uppercase"
  },
  printPanelTitleHint: {
    display: "block",
    marginTop: "3px",
    color: "#64748b",
    fontSize: "9px",
    fontWeight: "bold",
    letterSpacing: 0,
    textTransform: "none"
  },
  printPanelCell: {
    border: "1px solid #cbd5e1",
    borderTop: "0",
    padding: "12px 10px",
    fontSize: "12px",
    lineHeight: 1.45,
    color: "#334155",
    verticalAlign: "top"
  },
  printPanelCellAlt: {
    border: "1px solid #bfdbfe",
    borderTop: "0",
    padding: "12px 10px",
    fontSize: "12px",
    lineHeight: 1.45,
    color: "#334155",
    verticalAlign: "top",
    backgroundColor: "#f8fbff"
  },
  printAddressMeta: {
    margin: "0 0 6px",
    padding: 0,
    color: "#64748b",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: "0.05em",
    textTransform: "uppercase"
  },
  printAddressLine: {
    margin: "0 0 5px",
    padding: 0,
    color: "#475569",
    fontSize: "11px"
  },
  printAddressName: {
    margin: "0 0 6px",
    padding: 0,
    color: "#111827",
    fontSize: "14px",
    fontWeight: "bold"
  },
  printDetailTable: {
    width: "100%",
    borderCollapse: "collapse",
    margin: "8px 0 16px",
    border: "1px solid #bfdbfe",
    backgroundColor: "#ffffff",
    tableLayout: "fixed"
  },
  printDetailTitle: {
    padding: "7px 9px",
    border: "1px solid #bfdbfe",
    backgroundColor: "#eff6ff",
    color: "#334155",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: "0.05em",
    textTransform: "uppercase"
  },
  printDetailLabel: {
    width: "17%",
    padding: "7px 8px",
    border: "1px solid #e2e8f0",
    color: "#64748b",
    fontSize: "10px",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    backgroundColor: "#f8fafc"
  },
  printDetailValue: {
    width: "33%",
    padding: "7px 8px",
    border: "1px solid #e2e8f0",
    color: "#111827",
    fontSize: "10px",
    fontWeight: "bold",
    verticalAlign: "middle",
    wordBreak: "break-word"
  },
  printTable: {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid #cbd5e1",
    margin: "0 0 16px",
    backgroundColor: "#ffffff",
    tableLayout: "fixed"
  },
  printTableTitleCell: {
    padding: "9px 10px",
    border: "1px solid #cbd5e1",
    backgroundColor: "#f8fafc",
    color: "#0f172a",
    fontSize: "12px",
    fontWeight: "bold",
    letterSpacing: "0.04em",
    textTransform: "uppercase"
  },
  printTableHeadCell: {
    backgroundColor: "#334155",
    border: "1px solid #334155",
    color: "#ffffff",
    fontSize: "9px",
    fontWeight: "bold",
    letterSpacing: "0.04em",
    padding: "8px 7px",
    textAlign: "left",
    textTransform: "uppercase",
    verticalAlign: "middle"
  },
  printTableHeadCellRight: {
    backgroundColor: "#334155",
    border: "1px solid #334155",
    color: "#ffffff",
    fontSize: "9px",
    fontWeight: "bold",
    letterSpacing: "0.04em",
    padding: "8px 7px",
    textAlign: "right",
    textTransform: "uppercase",
    verticalAlign: "middle"
  },
  printTableCell: {
    border: "1px solid #e2e8f0",
    color: "#111827",
    fontSize: "10px",
    lineHeight: 1.35,
    padding: "9px 7px",
    verticalAlign: "top",
    wordBreak: "break-word"
  },
  printTableCellRight: {
    border: "1px solid #e2e8f0",
    color: "#111827",
    fontSize: "10px",
    lineHeight: 1.35,
    padding: "9px 7px",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap"
  },
  printTableFinalCell: {
    border: "1px solid #bfdbfe",
    backgroundColor: "#eff6ff",
    color: "#0f172a",
    fontSize: "11px",
    fontWeight: "bold",
    lineHeight: 1.35,
    padding: "9px 7px",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap"
  },
  printSummarySpacerCell: {
    border: "0",
    backgroundColor: "#ffffff",
    padding: 0
  },
  printSummaryGapCell: {
    border: "0",
    backgroundColor: "#ffffff",
    fontSize: "1px",
    height: "20px",
    lineHeight: "20px",
    padding: 0
  },
  printSummaryMiniGapCell: {
    border: "0",
    backgroundColor: "#ffffff",
    fontSize: "1px",
    height: "5px",
    lineHeight: "5px",
    padding: 0
  },
  printTotalLabel: {
    backgroundColor: "#f8fafc",
    color: "#334155",
    fontSize: "11px",
    fontWeight: "bold",
    padding: "10px 9px",
    textAlign: "right",
    border: "1px solid #e2e8f0"
  },
  printTotalValue: {
    backgroundColor: "#f8fafc",
    color: "#111827",
    fontSize: "11px",
    fontWeight: "bold",
    padding: "10px 9px",
    textAlign: "right",
    border: "1px solid #e2e8f0"
  },
  printGrandTotalLabel: {
    backgroundColor: "#0f172a",
    border: "1px solid #0f172a",
    color: "#ffffff",
    fontSize: "13px",
    fontWeight: "bold",
    padding: "12px 9px",
    textAlign: "right"
  },
  printGrandTotalValue: {
    backgroundColor: "#0f172a",
    border: "1px solid #0f172a",
    color: "#ffffff",
    fontSize: "13px",
    fontWeight: "bold",
    padding: "12px 9px",
    textAlign: "right"
  },
  printServiceBox: {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid #cbd5e1",
    backgroundColor: "#ffffff",
    marginBottom: "18px",
    marginTop: "38px",
    paddingTop: "30px",
    tableLayout: "fixed"
  },
  printServiceTitleCell: {
    width: "20%",
    border: "1px solid #cbd5e1",
    backgroundColor: "#f8fafc",
    color: "#475569",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: "0.06em",
    padding: "10px 12px",
    textTransform: "uppercase",
    verticalAlign: "top"
  },
  printServiceTextCell: {
    border: "1px solid #cbd5e1",
    backgroundColor: "#ffffff",
    color: "#334155",
    fontSize: "11px",
    lineHeight: 1.5,
    padding: "10px 12px",
    verticalAlign: "top"
  },
  printSignatureBlock: {
    border: "1px solid #cbd5e1",
    backgroundColor: "#ffffff",
    marginTop: "18px",
    padding: "0",
    color: "#334155"
  },
  printSignatureGrid: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    border: "1px solid #cbd5e1",
  },
  printSignatureCell: {
    width: "35%",
    border: "1px solid #e2e8f0",
    backgroundColor: "#f8fafc",
    padding: "12px",
    verticalAlign: "top"
  },
  printSignatureAuditCell: {
    border: "1px solid #e2e8f0",
    padding: "12px",
    verticalAlign: "top"
  },
  printSignatureLabel: {
    color: "#64748b",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: "0.06em",
    margin: "0 0 8px",
    padding: 0,
    textTransform: "uppercase"
  },
  printSignatureText: {
    fontStyle: "italic",
    fontWeight: "800",
    fontSize: "18px",
    lineHeight: 1.2,
    margin: "0 0 6px",
    padding: 0,
    color: "#0f172a"
  },
  printSignatureHint: {
    color: "#64748b",
    fontSize: "10px",
    fontWeight: "bold",
    margin: 0,
    padding: 0
  },
  printAuditTable: {
    width: "100%",
    borderCollapse: "collapse"
  },
  printAuditLabel: {
    width: "25%",
    color: "#64748b",
    fontSize: "10px",
    fontWeight: "bold",
    padding: "3px 8px 3px 0",
    verticalAlign: "top",
    whiteSpace: "nowrap"
  },
  printAuditValue: {
    color: "#111827",
    fontSize: "10px",
    fontWeight: "bold",
    padding: "3px 0",
    verticalAlign: "top",
    wordBreak: "break-word"
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap"
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  invoiceSubRef: {
    fontSize: "20px",
    color: "#2563eb",
    fontWeight: "bold",
    paddingTop: "10px"
  },
};

const GenerateInvoice = (props) => {
  const { invoiceNumber, genShowHide, handleGenShowHide, candidateObj,
    selectedObj, wfTask, timeLogInvoices, invNumber, logoPicObj, logoData, allRates } = props;
  // const [ipAddress, setIpAddress] = useState("");
  const [rate, setRate] = useState(0);
  // const [esignName, setEsignName] = useState("");
  const [candidateList, setCandidateList] = useState([]);
  const [pdfBtnProccess, setPdfBtnProccess] = useState(false);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [generateCount, setGenerateCount] = useState(0);

  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const generatedInvPdfSelector = useSelector(getGeneratedInvPdf);
  const generateBulkInvoiceStatusSelector = useSelector(getGenerateBulkInvoiceStatus);

  const usrType = localStorage.getItem("userType");
  const printBodyRef = useRef(null);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  const currentUserId = currentUser?.linkUser || currentUser?.id;

  // RTK Query: Declarative Loading of User Details
  useGetUserDetailsQuery(currentUserId, { skip: !currentUserId });

  const userDetails = userDetailsSelector;

  const ddName = useMemo(() => {
    if (!candidateObj) return "";
    return usrType === "recruiter" ? "recruiterenrollmentform" : "subcontractorenrollmentform";
  }, [candidateObj, usrType]);

  const partnerId = useMemo(() => {
    if (!candidateObj) return 0;
    if (usrType === "recruiter") {
      return parseInt(candidateObj.activeloans, 10) > 0 ? candidateObj.activeloans : 0;
    } else {
      return parseInt(candidateObj.loanamountlimit, 10) > 0 ? candidateObj.loanamountlimit : 0;
    }
  }, [candidateObj, usrType]);

  // RTK Query: Declarative Loading of Partner Candidate Report
  const { data: candidatesReport } = useLoadPartnerAllCandidateRptQuery(
    {
      year: selectedObj?.year,
      month: selectedObj?.month,
      partId: partnerId,
      type: usrType,
      candId: selectedObj?.candidateId,
    },
    {
      skip: !selectedObj || !candidateObj || !partnerId,
    }
  );

  const [partnerCandidateGenerateBulkInvMutation] = usePartnerCandidateGenerateBulkInvMutation();
  const [printGeneratedInvoiceMutation] = usePrintGeneratedInvoiceMutation();

  // useEffect(() => {
  //   const loadIpAddress = async () => {
  //     try {
  //       const ipv4 = await publicIp.v4() || "";
  //       setIpAddress(ipv4);
  //     } catch (err) {
  //       console.error("Failed to load IP address", err);
  //     }
  //   };
  //   loadIpAddress();
  // }, []);

  // useEffect(() => {
  //   if (!genShowHide) {
  //     setEsignName("");
  //   }
  // }, [genShowHide]);

  const getApplicableRateDetails = useCallback((item) => {
    const itemYear = parseInt(item?.year, 10);
    const itemMonth = parseInt(item?.month, 10);
    const rateField = usrType === "recruiter" ? "recruiterRate" : "subcontractorRate";
    const dateField = usrType === "recruiter" ? "recruiterEffectiveDate" : "subcontractorEffectiveDate";

    let candidateRate = 0;
    if (candidateObj?.rates?.recruiterRate > 0 && usrType === "recruiter")
      candidateRate = candidateObj.rates?.recruiterRate;

    if (candidateObj?.rates?.subcontractorRate > 0 && usrType !== "recruiter")
      candidateRate = candidateObj.rates?.subcontractorRate;

    const matchedRate = Array.isArray(allRates)
      ? allRates.reduce((best, currentRate, index) => {
        if (!itemYear || !itemMonth) return best;

        const effMs = new Date(currentRate?.[dateField]).getTime();
        if (Number.isNaN(effMs)) return best;

        const effDt = new Date(effMs);
        const effYear = effDt.getFullYear();
        const effMonth = effDt.getMonth() + 1;
        const isApplicable =
          effYear < itemYear ||
          (effYear === itemYear && effMonth <= itemMonth);

        if (!isApplicable) return best;
        if (!best) return { rate: currentRate, index, effMs };

        if (effMs > best.effMs) return { rate: currentRate, index, effMs };
        if (effMs < best.effMs) return best;

        const addedMs = new Date(currentRate?.addedDateTime).getTime();
        const bestAddedMs = new Date(best.rate?.addedDateTime).getTime();
        const safeAddedMs = Number.isNaN(addedMs) ? -Infinity : addedMs;
        const safeBestAddedMs = Number.isNaN(bestAddedMs) ? -Infinity : bestAddedMs;

        if (safeAddedMs > safeBestAddedMs) return { rate: currentRate, index, effMs };
        if (safeAddedMs < safeBestAddedMs) return best;

        const idNum = Number(currentRate?.id);
        const bestIdNum = Number(best.rate?.id);
        const safeIdNum = Number.isFinite(idNum) ? idNum : -Infinity;
        const safeBestIdNum = Number.isFinite(bestIdNum) ? bestIdNum : -Infinity;

        if (safeIdNum > safeBestIdNum) return { rate: currentRate, index, effMs };
        if (safeIdNum < safeBestIdNum) return best;

        return index > best.index ? { rate: currentRate, index, effMs } : best;
      }, null)?.rate
      : null;

    const fallbackRate = parseFloat(candidateRate || 0);
    const rateValue =
      matchedRate?.[rateField] !== null &&
        matchedRate?.[rateField] !== undefined &&
        matchedRate?.[rateField] !== ""
        ? parseFloat(matchedRate[rateField])
        : fallbackRate;

    const effectiveDate = matchedRate?.[dateField] || candidateRate;

    return {
      rate: rateValue,
      effectiveDate,
    };
  }, [usrType, candidateObj, allRates]);

  useEffect(() => {
    if (selectedObj && candidateObj) {
      const { rate: applicableRate } = getApplicableRateDetails(selectedObj);
      setRate(applicableRate);
    }
  }, [selectedObj, candidateObj, getApplicableRateDetails]);

  useEffect(() => {
    if (candidatesReport) {
      setCandidateList(candidatesReport);
    }
  }, [candidatesReport]);

  const getPdfReadyHtml = useCallback(() => {
    return printBodyRef.current ? printBodyRef.current.outerHTML : "";
  }, []);

  const handleSaveGenerate = useCallback(() => {
    setSaveBtnProccess(true);

    const htmlBody = getPdfReadyHtml();
    const currentUserId = currentUser?.linkUser || currentUser?.id;

    candidateList.forEach((item, key) => {
      const cObj = { ...item };
      if (invoiceNumber)
        cObj.invoiceNumber = invoiceNumber;

      const frmData = new FormData();
      frmData.append("html", htmlBody);
      frmData.append("candidate", JSON.stringify(cObj));
      frmData.append("sign", "");
      frmData.append("remarks", "Invoice");
      frmData.append("userId", currentUserId);
      frmData.append("workflowTask", JSON.stringify(wfTask));

      partnerCandidateGenerateBulkInvMutation(frmData);
      setGenerateCount(key + 1);
    });
  }, [candidateList, getPdfReadyHtml, invoiceNumber, currentUser, wfTask, partnerCandidateGenerateBulkInvMutation]);

  useEffect(() => {
    if (generateBulkInvoiceStatusSelector && generateCount === candidateList.length) {
      setSaveBtnProccess(false);
      getAlert("", "Generated and Sent Successfully", "success");
      setGenerateCount(0);
      dispatch(partnerCandidatesInvGenerated(false));
      setCandidateList([]);
      handleGenShowHide("save");
    }
  }, [generateBulkInvoiceStatusSelector, generateCount, candidateList.length, handleGenShowHide, dispatch]);

  const handlePrintPdf = useCallback(async () => {
    try {
      setPdfBtnProccess(true);

      const htmlBody = getPdfReadyHtml();

      const frmData = new FormData();
      frmData.append("html", htmlBody);
      await printGeneratedInvoiceMutation(frmData).unwrap();
    } catch (err) {
      console.error("Error creating image:", err);
      setPdfBtnProccess(false);
    }
  }, [getPdfReadyHtml, printGeneratedInvoiceMutation]);

  const doSubmit = useCallback(() => {
    handlePrintPdf();
  }, [handlePrintPdf]);

  useEffect(() => {
    if (generatedInvPdfSelector?.size > 0) {
      const url = window.URL.createObjectURL(generatedInvPdfSelector);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      dispatch(generatedInvoiePdfReceived(null));
      setPdfBtnProccess(false);
    }
  }, [generatedInvPdfSelector, dispatch]);

  const getAdjustmentAmout = useCallback((item) => {
    const invItem = timeLogInvoices.find(x => x.timeLogId === item.id);

    if (!invItem) {
      return <span>0.00</span>;
    }

    const adjMinus = parseFloat(invItem.adjustmentMinues || 0);
    const adjPlus = parseFloat(invItem.adjustmentPlus || 0);
    const adpDeduction = parseFloat(invItem.adpDeduction || 0);

    const adjustment = -adjMinus + adjPlus - adpDeduction;

    return <span>{adjustment.toFixed(2)}</span>;
  }, [timeLogInvoices]);

  const getFinalAmout = useCallback((item, currentRate) => {
    let fAmt = getTotalHours(item?.workingHrs) * currentRate;

    const invItem = timeLogInvoices.find(x => x.timeLogId === item.id);

    if (!invItem) {
      return fAmt.toFixed(2);
    }

    const adjMinus = parseFloat(invItem?.adjustmentMinues || 0);
    const adjPlus = parseFloat(invItem?.adjustmentPlus || 0);
    const adpDeduction = parseFloat(invItem?.adpDeduction || 0);

    fAmt = fAmt - adjMinus + adjPlus - adpDeduction;

    return fAmt.toFixed(2);
  }, [timeLogInvoices]);

  const getInvoiceFieldValue = useCallback((fieldName) => {
    if (!wfTask?.stateData || !ddName) return "";

    return getFieldData(wfTask.stateData, ddName, fieldName) ?? "";
  }, [wfTask, ddName]);

  const getPerformerFieldValue = useCallback((fieldName) => {
    if (!userDetails?.performerData || !ddName) return "";

    return getFieldData(userDetails.performerData, ddName, fieldName) ?? "";
  }, [userDetails, ddName]);

  const invoiceFromCompanyName = getPrintDetailValue(getPerformerFieldValue("Company_Name"));
  const invoiceFromAddressLine = getPrintDetailValue(getInvoiceFieldValue("Company_Address_Line1"));
  const invoiceFromCityStateZip = getPrintDetailValue(
    getCityStateZipLine(
      getInvoiceFieldValue("Company_City"),
      getInvoiceFieldValue("Company_State"),
      getInvoiceFieldValue("Company_Zip_Code")
    )
  );

  const invoiceContactPhone = [
    getInvoiceFieldValue("Company_Phone_Code"),
    getInvoiceFieldValue("Company_Phone")
  ]
    .map((value) => String(value ?? "").trim())
    .filter(Boolean)
    .join(" ");

  const printDetailRows = [
    [
      { label: "ID", value: getPrintDetailValue(partnerId) },
      { label: "Phone", value: getPrintDetailValue(invoiceContactPhone) }
    ],
    [
      { label: "Federal ID", value: getPrintDetailValue(getInvoiceFieldValue("Federal_ID")) },
      { label: "Email", value: getPrintDetailValue(getInvoiceFieldValue("Company_Email")) },
    ]
  ];

  const invoiceDateValue = formatDateMMDDYYYY();
  const paymentTermValue = "Net 30 Days";
  // const paymentDueDateValue = formatDateMMDDYYYY(getDateAfterDays(30));
  // const signatureDisplayName = getPrintDetailValue(esignName);
  // const signedOnValue = new Date().toUTCString();
  // const signedUserName = getPrintDetailValue(`${userDetails?.performername || ""} ${userDetails?.lastName || ""}`);
  // const signerIpAddress = getPrintDetailValue(ipAddress);

  const agencyName = getFieldData(
    candidateObj?.performerData,
    "projectengagement",
    "AgencyName"
  ) || "N/A";

  const agencyState = getFieldData(
    candidateObj?.performerData,
    "projectengagement",
    "State"
  ) || "N/A";

  return (
    <Modal
      show={genShowHide}
      size="xl"
      centered
      onHide={() => handleGenShowHide("")}
      dialogClassName="generate-invoice-modal-dialog"
      contentClassName="generate-invoice-modal-content"
    >
      <style>{`
        .generate-invoice-modal-dialog {
          max-width: ${GENERATE_INVOICE_STYLES.modalDialog.maxWidth};
        }
        .generate-invoice-modal-content {
          border-radius: ${GENERATE_INVOICE_STYLES.modalContent.borderRadius};
          overflow: ${GENERATE_INVOICE_STYLES.modalContent.overflow};
          border: ${GENERATE_INVOICE_STYLES.modalContent.border};
          box-shadow: ${GENERATE_INVOICE_STYLES.modalContent.boxShadow};
        }
      `}</style>
      <Modal.Header style={GENERATE_INVOICE_STYLES.modalHeader}>
        <div style={GENERATE_INVOICE_STYLES.headerContent}>
          <Modal.Title as="div" style={GENERATE_INVOICE_STYLES.titleWrap}>
            <span style={GENERATE_INVOICE_STYLES.headerIcon}>
              <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
            </span>
            <div>
              <div style={GENERATE_INVOICE_STYLES.eyebrow}>Invoice Preview</div>
              <h2 style={GENERATE_INVOICE_STYLES.title}>Generate Invoice</h2>
              <div style={GENERATE_INVOICE_STYLES.subtitle}>
                Review the generated invoice before sending it or printing a PDF.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={GENERATE_INVOICE_STYLES.closeButton}
            onClick={() => handleGenShowHide("")}
            aria-label="Close generate invoice popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>
      <Modal.Body style={GENERATE_INVOICE_STYLES.modalBody}>
        <div style={GENERATE_INVOICE_STYLES.helperCard}>
          <div style={GENERATE_INVOICE_STYLES.helperTitle}>Ready to generate</div>
          <p style={GENERATE_INVOICE_STYLES.helperText}>
            Confirm the invoice preview, then send it into the workflow or open a printable PDF copy.
          </p>
        </div>
        <div style={GENERATE_INVOICE_STYLES.previewCard}>
          <div style={GENERATE_INVOICE_STYLES.previewHeader}>
            <div>
              <div style={GENERATE_INVOICE_STYLES.previewTitle}>Invoice Document</div>
              <div style={GENERATE_INVOICE_STYLES.previewSubtitle}>
                This preview is used for both PDF printing and invoice submission.
              </div>
            </div>
            <span style={GENERATE_INVOICE_STYLES.invoicePill}>
              <i className="fa fa-hashtag" aria-hidden="true"></i>
              {invNumber || "Invoice Number"}
            </span>
          </div>
          <div style={GENERATE_INVOICE_STYLES.previewShell}>
            <div id="printBodyRef" ref={printBodyRef} style={GENERATE_INVOICE_STYLES.printBody}>
              <table
                width="100%"
                cellSpacing="0"
                border="0"
                style={GENERATE_INVOICE_STYLES.printHeaderTable}
              >
                <tbody>
                  <tr>
                    <td style={GENERATE_INVOICE_STYLES.printHeaderLogoCell}>
                      {(logoPicObj?.imagePreviewUrl || logoData) && (
                        <img
                          id="Img1"
                          alt="Company Logo"
                          src={logoPicObj?.imagePreviewUrl || `${process.env.REACT_APP_API_BASEURL}/CompanyLogo/${logoData}`}
                          style={GENERATE_INVOICE_STYLES.printLogo}
                        />
                      )}
                    </td>
                    <td style={GENERATE_INVOICE_STYLES.printHeaderTitleCell}>
                      <p style={GENERATE_INVOICE_STYLES.printTitleText}>INVOICE</p>
                      <p style={GENERATE_INVOICE_STYLES.invoiceSubRef}>#{invNumber}</p>
                      <p style={GENERATE_INVOICE_STYLES.printHeaderSubText}>Generated electronic invoice</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table width="100%" cellSpacing="0" border="0" style={GENERATE_INVOICE_STYLES.printMetaTable}>
                <tbody>
                  <tr>
                    <td width="50%" style={GENERATE_INVOICE_STYLES.printMetaCell}>
                      <p style={GENERATE_INVOICE_STYLES.printMetaLabel}>Invoice Date</p>
                      <p style={GENERATE_INVOICE_STYLES.printMetaValue}>{invoiceDateValue}</p>
                      {/* <p style={GENERATE_INVOICE_STYLES.printMetaHint}>Date of issue</p> */}
                    </td>
                    <td width="50%" style={GENERATE_INVOICE_STYLES.printMetaCellAlt}>
                      <p style={GENERATE_INVOICE_STYLES.printMetaLabel}>Payment Term</p>
                      <p style={GENERATE_INVOICE_STYLES.printMetaValue}>{paymentTermValue}</p>
                      {/* <p style={GENERATE_INVOICE_STYLES.printMetaHint}>Due by {paymentDueDateValue}</p> */}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                cellPadding="10"
                cellSpacing="0"
                width="100%"
                border="0"
                style={GENERATE_INVOICE_STYLES.printPartyTable}
              >
                <tbody>
                  <tr>
                    <td
                      style={GENERATE_INVOICE_STYLES.printPanelTitle}
                      width="55%"
                    >
                      Invoice From
                    </td>
                    <td
                      style={GENERATE_INVOICE_STYLES.printPanelTitleAlt}
                      width="45%"
                    >
                      Invoice To
                    </td>
                  </tr>
                  <tr>
                    <td style={GENERATE_INVOICE_STYLES.printPanelCell} width="55%" valign="top">
                      <p style={GENERATE_INVOICE_STYLES.printAddressMeta}>{usrType === "recruiter" ? "RECRUITER" : "SUBCONTRACTOR"}</p>
                      <p style={GENERATE_INVOICE_STYLES.printAddressName}>
                        {invoiceFromCompanyName}
                      </p>
                      <p style={GENERATE_INVOICE_STYLES.printAddressLine}>
                        {invoiceFromAddressLine}
                      </p>
                      <p style={GENERATE_INVOICE_STYLES.printAddressLine}>
                        {invoiceFromCityStateZip}
                      </p>
                    </td>
                    <td style={GENERATE_INVOICE_STYLES.printPanelCellAlt} width="45%" valign="top">
                      <p style={GENERATE_INVOICE_STYLES.printAddressMeta}>CLIENT</p>
                      <p style={GENERATE_INVOICE_STYLES.printAddressName}>
                        IPCS Inc.
                      </p>
                      <p style={GENERATE_INVOICE_STYLES.printAddressLine}>600 Highway 169 South</p>
                      <p style={GENERATE_INVOICE_STYLES.printAddressLine}>METROPOINT, Suite 1595</p>
                      <p style={GENERATE_INVOICE_STYLES.printAddressLine}>Minneapolis, MN 55426</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table cellPadding="10" cellSpacing="0" border="0" style={GENERATE_INVOICE_STYLES.printDetailTable}>
                <tbody>
                  <tr>
                    <td colSpan={4} style={GENERATE_INVOICE_STYLES.printDetailTitle}>
                      {usrType === "recruiter" ? "Recruiter" : "Subcontractor"} Details
                    </td>
                  </tr>
                  {printDetailRows.map((detailRow) => (
                    <tr key={detailRow.map((detail) => detail.label).join("-")}>
                      {detailRow.map((detail) => (
                        <React.Fragment key={detail.label}>
                          <td style={GENERATE_INVOICE_STYLES.printDetailLabel}>{detail.label}</td>
                          <td style={GENERATE_INVOICE_STYLES.printDetailValue}>{detail.value}</td>
                        </React.Fragment>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="table-responsive">
                <table
                  cellPadding="10"
                  cellSpacing="0"
                  width="100%"
                  style={GENERATE_INVOICE_STYLES.printTable}
                  border="0"
                >
                  <thead>
                    <tr>
                      <th colSpan={7} style={GENERATE_INVOICE_STYLES.printTableTitleCell}>
                        Billing Summary
                      </th>
                    </tr>
                    <tr>
                      <th width="32%" style={GENERATE_INVOICE_STYLES.printTableHeadCell}>Candidate</th>
                      <th width="12%" style={GENERATE_INVOICE_STYLES.printTableHeadCell}>Period</th>
                      <th width="7%" style={GENERATE_INVOICE_STYLES.printTableHeadCellRight}>Hours</th>
                      <th width="11%" style={GENERATE_INVOICE_STYLES.printTableHeadCellRight}>Rate/$Hr</th>
                      <th width="11%" style={GENERATE_INVOICE_STYLES.printTableHeadCellRight}>Invoice ($)</th>
                      <th width="13%" style={GENERATE_INVOICE_STYLES.printTableHeadCellRight}>Adjustment ($)</th>
                      <th width="14%" style={GENERATE_INVOICE_STYLES.printTableHeadCellRight}>Final Amount ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        style={GENERATE_INVOICE_STYLES.printTableCell}
                      >
                        <p style={{ fontWeight: 'bold' }}>#{candidateObj && candidateObj.performerid}</p>
                        <p>{candidateObj && candidateObj.performername} {candidateObj && candidateObj.lastName}</p>
                        <p>Agency : {agencyName}</p>
                        <p>Location : {agencyState}</p>
                      </td>
                      <td
                        style={GENERATE_INVOICE_STYLES.printTableCell}
                      >
                        {selectedObj && getMonthlyPeriod(selectedObj)}
                      </td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printTableCellRight}
                      >
                        {selectedObj && formatTotalHours(selectedObj.workingHrs)}
                      </td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printTableCellRight}
                      >
                        {(rate).toFixed(2) || 0}
                      </td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printTableCellRight}
                      >
                        {selectedObj && (getTotalHours(selectedObj.workingHrs) * rate).toFixed(2)}
                      </td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printTableCellRight}
                      >
                        {selectedObj && getAdjustmentAmout(selectedObj)}
                      </td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printTableFinalCell}
                      >
                        {selectedObj && getFinalAmout(selectedObj, rate)}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={7} style={GENERATE_INVOICE_STYLES.printSummaryGapCell}>
                        &nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td
                        colSpan={5}
                        style={GENERATE_INVOICE_STYLES.printSummarySpacerCell}
                      ></td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printTotalLabel}
                      >
                        SubTotal ($)
                      </td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printTotalValue}
                      >
                        {selectedObj && getFinalAmout(selectedObj, rate)}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={7} style={GENERATE_INVOICE_STYLES.printSummaryMiniGapCell}>
                        &nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td
                        colSpan={5}
                        style={GENERATE_INVOICE_STYLES.printSummarySpacerCell}
                      ></td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printGrandTotalLabel}
                      >
                        Total ($)
                      </td>
                      <td
                        align="right"
                        style={GENERATE_INVOICE_STYLES.printGrandTotalValue}
                      >
                        {selectedObj && getFinalAmout(selectedObj, rate)}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>


              <table width="100%" cellPadding="10" cellSpacing="0" border="0" style={GENERATE_INVOICE_STYLES.printServiceBox}>
                <tbody>
                  <tr>
                    <td style={GENERATE_INVOICE_STYLES.printServiceTitleCell}>
                      Service Note
                    </td>
                    <td style={GENERATE_INVOICE_STYLES.printServiceTextCell}>
                      As per IT consulting services agreement and purchase order. Thank you for your business.
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* <table width="100%" cellPadding="10" cellSpacing="0" border="0" style={GENERATE_INVOICE_STYLES.printSignatureGrid}>
                <tbody>
                  <tr>
                    <td style={GENERATE_INVOICE_STYLES.printSignatureCell}>
                      <p style={GENERATE_INVOICE_STYLES.printSignatureLabel}>Authorized Signature</p>
                      <p style={GENERATE_INVOICE_STYLES.printSignatureText}>{signatureDisplayName}</p>
                      <p style={GENERATE_INVOICE_STYLES.printSignatureHint}>Electronically signed</p>
                    </td>
                    <td style={GENERATE_INVOICE_STYLES.printSignatureAuditCell}>
                      <p style={GENERATE_INVOICE_STYLES.printSignatureLabel}>Signature Audit</p>
                      <table width="100%" cellPadding="0" cellSpacing="0" border="0" style={GENERATE_INVOICE_STYLES.printAuditTable}>
                        <tbody>
                          <tr>
                            <td style={GENERATE_INVOICE_STYLES.printAuditLabel}>Signed On</td>
                            <td style={GENERATE_INVOICE_STYLES.printAuditValue}>{signedOnValue}</td>
                          </tr>
                          <tr>
                            <td style={GENERATE_INVOICE_STYLES.printAuditLabel}>IP Address</td>
                            <td style={GENERATE_INVOICE_STYLES.printAuditValue}>{signerIpAddress}</td>
                          </tr>
                          <tr>
                            <td style={GENERATE_INVOICE_STYLES.printAuditLabel}>Signed By</td>
                            <td style={GENERATE_INVOICE_STYLES.printAuditValue}>{signedUserName}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table> */}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={GENERATE_INVOICE_STYLES.modalFooter}>
        <div style={GENERATE_INVOICE_STYLES.footerActions}>
          <button
            className="btn btn-sm"
            style={GENERATE_INVOICE_STYLES.subtleButton}
            onClick={() => handleGenShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>

          <button className="btn btn-sm"
            style={GENERATE_INVOICE_STYLES.primaryButton}
            disabled={pdfBtnProccess}
            onClick={doSubmit}>
            {pdfBtnProccess ? <i className="fa fa-spinner fa-spin"></i> :
              <i className="fa fa-print" aria-hidden="true"></i>} Print PDF
          </button>
          <button className="btn btn-sm"
            style={GENERATE_INVOICE_STYLES.primaryButton}
            disabled={saveBtnProccess}
            onClick={handleSaveGenerate}>
            {saveBtnProccess ? <i className="fa fa-spinner fa-spin"></i> :
              <i className="fa fa-paper-plane" aria-hidden="true"></i>} Generate & Send
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

const formatDateMMDDYYYY = (date = new Date()) => {
  const parsedDate = date instanceof Date ? date : new Date(date);
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");
  const year = parsedDate.getFullYear();
  return `${month}/${day}/${year}`;
};

// const getDateAfterDays = (days) => {
//   const date = new Date();
//   date.setDate(date.getDate() + days);
//   return date;
// };

const getPrintDetailValue = (value) => {
  const normalizedValue = String(value ?? "").trim();
  return normalizedValue || "-";
};

const getCityStateZipLine = (city, state, zip) => {
  const cityText = String(city ?? "").trim();
  const stateZipText = [state, zip]
    .map((value) => String(value ?? "").trim())
    .filter(Boolean)
    .join(" ");

  return [cityText, stateZipText].filter(Boolean).join(", ");
};

const getMonthlyPeriod = (obj) => {
  if (!obj?.workingHrs) return "";

  let wt;
  try {
    wt = JSON.parse(obj.workingHrs);
  } catch (e) {
    return "";
  }

  if (!Array.isArray(wt) || wt.length === 0) return "";

  const sortWt = [...wt].sort(
    (a, b) => new Date(a.start) - new Date(b.start)
  );

  const first = sortWt[0];
  const last = sortWt[sortWt.length - 1];

  const lastDate =
    last.type === "m"
      ? getMonthLastDay(last.start)
      : last.start;

  return (
    <p>
      {formatDateMMDDYYYY(first.start)} -{" "}
      {formatDateMMDDYYYY(lastDate)}
    </p>
  );
};

// const getEmergencyFoundImg = (url) => {
//   return new Promise((resolve) => {
//     const img = new Image();
// 
//     // Set CORS before src
//     img.crossOrigin = "anonymous";
//     img.src = url;
// 
//     img.onload = () => {
//       const c = document.createElement("canvas");
//       c.width = img.naturalWidth;
//       c.height = img.naturalHeight;
// 
//       const ctx = c.getContext("2d");
//       ctx.drawImage(img, 0, 0);
// 
//       try {
//         const base64String = c.toDataURL("image/png");
// 
//         const img2 = document.createElement("img");
//         img2.src = base64String;
//         img2.style.height = "90px";
//         img2.style.width = "auto";
//         img2.style.borderRadius = "10px";
//         img2.style.marginBottom = "5px";
// 
//         resolve(img2);
//       } catch (e) {
//         // In case of toDataURL failure, return empty string
//         resolve('');
//       }
//     };
// 
//     // Instead of rejecting, resolve with empty string on error
//     img.onerror = () => {
//       resolve('');
//     };
//   });
// };

export default GenerateInvoice;
